import type { Product } from '../types/product';

/**
 * Helper to build the correct detail URL for a product coming from Supabase.
 * Kept separate so routing logic stays in one place.
 */
export function getProductDetailPath(product: Product): string {
  if (product.type === 'preset') {
    return `/presets/${product.slug}`;
  }
  if (product.type === 'template') {
    return `/templates/${product.slug}`;
  }
  return `/samples/${product.slug}`;
}

